import type { Company } from '@indutrust/shared-model';
import { createCrudSingleEvents } from '@indutrust/shared-util';

/**
 * Single-entity CRUD events for the active company in a detail view.
 *
 * Source namespace: `company.single` (visible in Redux DevTools). Use this
 * group when a component needs to load/edit a single company, independent of
 * the collection-oriented {@link companyEvents}.
 */
export const companySingleEvents =
  createCrudSingleEvents<Company>('company.single');
